export const isString = (value: unknown): value is string =>
  typeof value === 'string';

export const isObjectType = (value: unknown): value is object =>
  typeof value === 'object';

export const isNullOrUndefined = (value: unknown): value is null | undefined =>
  value == null;

export const isDateObject = (value: unknown): value is Date =>
  value instanceof Date;

const isIncludeKeyInObject = <T extends object>(
  obj: T,
  keys?: string[],
): boolean => {
  if (keys === undefined || keys.length === 0) return true;

  return keys.every(key => key in obj);
};

export const isObject = <T extends object>(
  value: unknown,
  keys?: string[],
): value is T =>
  !isNullOrUndefined(value) &&
  !Array.isArray(value) &&
  isObjectType(value) &&
  !isDateObject(value) &&
  isIncludeKeyInObject(value, keys);

/**
 * @name isNumber
 * @param value
 * @return Boolean
 * @description Проверяет классифицируется ли значение как числовой примитив
 */
export const isNumber = (value: unknown): value is number =>
  typeof value === 'number';

/**
 * @name isFunction
 * @description Проверяет классифицируется ли значение как функциея.
 * @param {unknown} value the value
 * @return {boolean} a boolean
 */
// eslint-disable-next-line @typescript-eslint/ban-types -- Allow proper function inference
export const isFunction = (value: unknown): value is Function =>
  typeof value === 'function';

/**
 * @name isBoolean
 * @param value
 * @return Boolean
 * @description Проверяет, классифицируется ли значение как булевой примитив
 */
export const isBoolean = (value: unknown): value is boolean =>
  typeof value === 'boolean';
